import React from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { NeutralBadge, Box } from '@hz-design-system/web-ui';
import getSuitCSSClasses from '@/utils/getSuitCSSClasses';

import Classes from './ListingTrustIndicators.module.scss';

interface ListingTrustIndicatorsProps {
  trustIndicators: { value?: string; key: string }[];
}

const ListingTrustIndicators: React.FC<ListingTrustIndicatorsProps> = ({ trustIndicators }) => {
  if (!trustIndicators?.length) {
    return null;
  }

  return (
    <Box as="div" name="trust-items" className={Classes['hz-Listing-trust-items']}>
      {trustIndicators.map((trustIndicator, key) => (
        <NeutralBadge
          className={getSuitCSSClasses({
            namespace: 'hz',
            name: 'Listing-trust-item-new',
          })}
          key={key}
        >
          <Trans tagName="span" i18nKey={`trustIndicator.${trustIndicator.key}`} />
        </NeutralBadge>
      ))}
    </Box>
  );
};

export default ListingTrustIndicators;
